import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=55a37666&"
import script from "./Payment.vue?vue&type=script&lang=ts&"
export * from "./Payment.vue?vue&type=script&lang=ts&"
import style0 from "./Payment.vue?vue&type=style&index=0&id=55a37666&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Guidance: require('C:/inetpub/wwwroot/bike-flights/components/guidance/Guidance.vue').default,PaymentMethod: require('C:/inetpub/wwwroot/bike-flights/components/PaymentMethod.vue').default,PolicyContent: require('C:/inetpub/wwwroot/bike-flights/components/PolicyContent.vue').default,Modal: require('C:/inetpub/wwwroot/bike-flights/components/Modal.vue').default,TermsOfServiceContent: require('C:/inetpub/wwwroot/bike-flights/components/TermsOfServiceContent.vue').default})
